import { api } from "./orgApi";

export async function getSubtabCatalog() {
  const { data } = await api.get("/access/subtabs/catalog");
  return data;
}

export async function getOrgSubtabDefaults({ userClass, organizationId }) {
  const { data } = await api.get("/access/subtabs/defaults", {
    params: { userClass, organizationId },
  });
  return data;
}

export async function saveOrgSubtabDefaults({ userClass, organizationId, matrix }) {
  const { data } = await api.put("/access/subtabs/defaults", {
    userClass,
    organizationId,
    matrix,
  });
  return data;
}

export async function listAccessEmployees({ organizationId } = {}) {
  const { data } = await api.get("/access/subtabs/users", {
    params: organizationId ? { organizationId } : {},
  });
  return data;
}

export async function getUserSubtabAccess(userId, { organizationId } = {}) {
  const { data } = await api.get(`/access/subtabs/users/${userId}`, {
    params: organizationId ? { organizationId } : {},
  });
  return data;
}

export async function saveUserSubtabAccess(userId, { organizationId, matrix }) {
  const { data } = await api.put(`/access/subtabs/users/${userId}`, {
    organizationId,
    matrix,
  });
  return data;
}

export async function resetUserSubtabAccess(userId, { organizationId } = {}) {
  const { data } = await api.post(
    `/access/subtabs/users/${userId}/reset`,
    {},
    { params: organizationId ? { organizationId } : {} },
  );
  return data;
}
